//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {required, email} from "vuelidate/lib/validators";
import CmsMetaMixin from "~/node_modules/sitis-nuxt/lib/mixins/CmsMetaMixin";

export default {
  data() {
    return {
      successMessage: "",
      email: "",
      isSubmiting: false,
    };
  },
  layout: "custom-layout",
  mixins: [CmsMetaMixin],
  validations: {
    email: {
      required,
      email,
    },
  },
  computed: {
    isRecaptchaTest() {
      return Boolean(Number.parseFloat(this.$store?.state?.appState?.config?.useReCaptchaForAuth || 0))
    },
  },
  methods: {
    async requestPassword() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return null;
      }

      this.isSubmiting = true;

      let newForm = {
        email: this.email,
      }

      if (this.isRecaptchaTest) {
        newForm['g-recaptcha-response'] = await this.$recaptcha.getResponse().then((res) => {
          return res
        }).catch(() => {
          return ""
        });
        await this.$recaptcha.reset();
      }

      const {data} = await this.$api.agent.transport
        .post("users/request", newForm)
        .catch((err) => {
          return {
            data: {
              errorMessage: err.response?.data?.[0]?.message || "server error",
            },
          };
        });
      this.email = "";
      this.$nextTick(() => {
        this.$v.$reset();
      });

      if (data?.errorMessage) {
        this.isSubmiting = false;
        this.$toast.error(data?.errorMessage);
        return null;
      }
      this.successMessage = this.$t("resetThePassword.message");
      this.isSubmiting = false;
    },
  },
};
